<template>
  <div>
    <!-- 回收站 -->
    <el-dialog
      title="回收站"
      :visible.sync="celbin" :close-on-click-modal="false">
      <el-table
          height="420"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column
            label="标题"
            width="260"
            align="center"
          >
            <template slot-scope="scope">
              {{ $functions.filterHtmlTag(scope.row.title) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="countFinish"
            label="收集数据"
            width="85"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="updateTime"
            label="删除时间"
            width="160"
            align="center"
          >
          </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        @size-change="handleSizeChange1"
        :page-size="pageSize2"
        background
        layout="prev, pager, next"
        :total="totals"
        @current-change="handleCurrentChange1"
      >
      </el-pagination>
      
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="recovery()">恢复</el-button>
        <el-button size="small" type="primary" @click="perDelete()">删除</el-button>
      </span>
    </el-dialog>
    <div class="w">
      <!-- header -->
      <SecondHead activeIndex="4" textColor="#333" color="#333"></SecondHead>
    </div>
    <div class="page-body">
      <div class="my-banner flex align-items justify-content">
        <div class="w">
          <el-row>
            <el-col :span="8">
              <div
                class="list-card-content flex justify-content column align-items"
                style="margin: 0px auto"
                @click="tocreate"
              >
                <img src="../../assets/icon_1.png" alt="" />
                <p>创建空白考试</p>
              </div>
            </el-col>
            <el-col :span="8">
              <div
                class="list-card-content flex justify-content column align-items"
                style="margin: 0px auto"
                @click="toImportQuest"
              >
                <img src="../../assets/icon_2.png" alt="" />
                <p>文本导入</p>
              </div>
            </el-col>
            <el-col :span="8">
              <div
                class="list-card-content flex justify-content column align-items"
                style="margin: 0px auto"
                @click="toTestQuestionBank"
              >
                <img src="../../assets/icon_5.png" alt="" />
                <p>自动组卷</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="w" style="padding-bottom: 40px;">
        <div class="my-title">我的考试</div>
        <div class="function flex align-items space-between">
          <div class="flex">
            <div class="flex align-items justify-content img-btn">
              <img
                src="../../assets/grid_icon_def.png"
                alt=""
                class="btn-img"
                v-show="gridShow == 0"
                style="margin-right: 15px"
                @click="switchType(1)"
              />
              <img
                src="../../assets/grid_icon_sel.png"
                alt=""
                class="btn-img"
                v-show="gridShow == 1"
                style="margin-right: 15px"
              />
              <img
                src="../../assets/list_icon_def.png"
                alt=""
                class="btn-table"
                v-show="listShow == 1"
                @click="switchType(2)"
              />
              <img
                src="../../assets/list_icon_sel.png"
                alt=""
                class="btn-table"
                v-show="listShow == 0"
              />
            </div>
            <div style="margin-left: 25px">
              <el-select
                :popper-append-to-body="false"
                v-model="search1.state"
                placeholder="考试状态"
                class="select-input"
                @change="search()"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div style="margin-left: 25px">
              <el-date-picker
                :append-to-body="false"
                v-model="search1.startTime"
                type="date"
                placeholder="创建时间"
                format="yyyy-MM-dd hh:mm:ss"
                value-format="yyyy-MM-dd hh:mm:ss"
                :editable="false"
                @change="search()"
              >
              </el-date-picker>
            </div>
            <div style="margin-left: 25px">
              <el-input
                placeholder="请输入内容"
                class="input-with-select"
                style="width: 260px"
                v-model="search1.title"
                :clearable="true"
                @keyup.enter.native="search()"
                @clear="search"
                :readonly="searchReadonly"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="search()"
                ></el-button>
              </el-input>
            </div>
          </div>
          <div class="flex align-items d-box"  @click="recyclebin()">
            <div class="del"></div>
            <p>回收站</p>
          </div>
        </div>

        <!--表格-->
        <div class="table"  v-loading="loading" v-show="state == 1">
          <el-table :data="examlist" style="width: 100%">
            <el-table-column
              prop="title"
              label="标题"
              width="310"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  style="cursor: pointer; padding: 5px"
                  @click="toedit(scope.row)"
                  >{{ $functions.filterHtmlTag(scope.row.title) }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="wjTypeName"
              label="类型"
              width="160"
              align="center"
            >
              <template slot-scope="scope">
                <span
                    v-if="scope.row.paperType == 1"
                    >考试</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="state"
              label="状态"
              width="160"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  style="font-size: 14px; color: #e96d08"
                  v-if="scope.row.state == 1"
                  >编辑中</span
                >
                <span
                  style="font-size: 14px; color: #1daa35"
                  v-if="scope.row.state == 2"
                  >征集中</span
                >
                <span
                  style="font-size: 14px; color: #0080ff"
                  v-if="scope.row.state == 3"
                  >已结束</span
                >
                <span
                  style="font-size: 14px; color: #ee3f48"
                  v-if="scope.row.state == 4"
                  >审核中</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="收集数据"
              width="160"
              align="center"
            >
              <template slot-scope="scope">
                <!-- <span
                  style="cursor: pointer; color: #0080ff"
                  @click="useNumber(scope.row)"
                  >{{ scope.row.countFinish }}</span
                > -->
                <span
                  style="cursor: pointer; color: #0080ff"
                  >{{ scope.row.countFinish }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="时间"
              width="165"
              align="center"
            >
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="flex align-items justify-content">
                  <span class="span" @click="toedit(scope.row)">编辑</span>
                  <span class="span" @click="previewClick(scope.row)"
                    >预览</span
                  >
                  <span class="span" @click="publish(scope.row)">发布</span>
                  <span class="span" @click="toViewData(scope.row)">数据</span>
                  
                  <span>
                    <el-dropdown trigger="click" placement="bottom" @command="(e)=>handleCommand(e, scope.row)">
                      <span class="el-dropdown-link flex align-items" style="cursor: pointer;height: 20px;">
                        <img  src="../../assets/more_icon.png" alt="" />
                      </span>
                      <el-dropdown-menu :append-to-body="false" :ref="`${scope.row.id}mydropdList`" slot="dropdown">
                        <el-dropdown-item command="copyQuestionnaire">复制项目</el-dropdown-item>
                        <el-dropdown-item command="wipeData">清空数据</el-dropdown-item>
                        <el-dropdown-item command="deleProject">删除项目</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <div :ref="'hereList'+ scope.row.id"></div>
                  </span>
								  <div :ref="'hereList'+ scope.row.id"></div>
                </div>
              </template>
            </el-table-column>
            
          </el-table>
          <div class="kong" v-if="this.examlist.length == 0">
              <img src="../../assets/empty.png" alt="" />
              <p>暂无数据</p>
            </div>
        </div>

        <!--图层-->
        <div class="grid flex" v-loading="loading" v-show="state == 2">
          <div class="grid-list"  v-for="item in examlist" :key="item.id">
            <div class="grid-list-img"><img :src="item.headImg" alt="" class="top-img" /></div>
            <div class="flex grid-title space-between">
              <p @click="toedit(item)" :title="item.title">
                {{ $functions.html2string(item.title) }}
              </p>
              <div v-if="item.paperType == 1" class="wq flex align-items justify-content">考试</div>
            </div>
            <div
              class="grid-list-bottm flex space-between align-items bottom_top"
            >
              <div>
                <span
                  style="font-size: 12px; color: #e96d08"
                  v-if="item.state == 1"
                  >编辑中</span
                >
                <span
                  style="font-size: 12px; color: #1daa35"
                  v-if="item.state == 2"
                  >征集中</span
                >
                <span
                  style="font-size: 12px; color: #0080ff"
                  v-if="item.state == 3"
                  >已结束</span
                >
                <span
                  style="font-size: 12px; color: #ee3f48"
                  v-if="item.state == 4"
                  >审核中</span
                >
              </div>
              <div style="color: #666; font-size: 12px">
                数据：{{ item.countFinish }}
              </div>
              <div style="color: #666; font-size: 12px">
                {{ item.createTime }}
              </div>
            </div>
            <div class="bottom-icon">
              <div class="grid-list-bottm flex space-between align-items">
                <div class="flex align-items" style="cursor: pointer">
                  <img src="../../assets/bj_icon.png" alt="" />
                  <span
                    style="color: #0080ff; font-size: 12px; margin-left: 5px"
                    @click="toedit(item)"
                    >编辑</span
                  >
                </div>
                <div
                  class="flex align-items"
                  style="cursor: pointer"
                  @click="previewClick(item)"
                >
                  <img src="../../assets/ylsel_icon.png" alt="" />
                  <span
                    style="color: #0080ff; font-size: 12px; margin-left: 5px"
                    >预览</span
                  >
                </div>
                <div class="flex align-items" style="cursor: pointer">
                  <img src="../../assets/fbsel_icon.png" alt="" />
                  <span
                    style="color: #0080ff; font-size: 12px; margin-left: 5px"
                    @click="publish(item)"
                    >发布</span
                  >
                </div>
                <div  class="flex align-items" style="cursor: pointer">
                  <!-- <img src="../../assets/fbsel_icon.png" alt="" /> -->
                  <i class="el-icon-s-data"></i>
                  <span
                    style="color: #0080ff; font-size: 12px; margin-left: 5px"
                    @click="toViewData(item)"
                    >数据</span
                  >
                </div>
                <el-dropdown trigger="click" placement="bottom" @command="(e)=>handleCommand(e, item)">
                  <span class="el-dropdown-link flex align-items" style="cursor: pointer;height: 20px;">
                    <img  src="../../assets/more_icon.png" alt="" />
                  </span>
                  <el-dropdown-menu style="width: 98px;" :append-to-body="false" :ref="`${item.id}mydropdCard`"  slot="dropdown">
                    <el-dropdown-item command="copyQuestionnaire">复制项目</el-dropdown-item>
                    <el-dropdown-item command="wipeData">清空数据</el-dropdown-item>
                    <el-dropdown-item command="deleProject">删除项目</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
		        <div ref="hereCard"></div>
          </div>
          <div class="kong" v-if="this.examlist.length == 0">
            <img src="../../assets/empty.png" alt="" />
            <p>暂无数据</p>
          </div>
        </div>
        <!--分页-->
        <div
          class="flex justify-content"
          style="margin-top: 10px;"
          v-if="this.examlist.length > 0"
        >
          <el-pagination
            :current-page="pageIndex"
            @size-change="handleSizeChange"
            :page-size="pageSize"
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import SecondHead from "@/components/SecondHead"
import qs from 'qs'
export default {
  name: "MyExam",
  components: {
    SecondHead,
  },
  data() {
    return {
      type: 1,
      listShow: 0,
      gridShow: 0,
      tipShow: 0,
      createTime: "",
      curStatus: 0,
      state: 1,
      examlist: [],
      total: 0,
      pageIndex: 1,
      pageSize: 12,
      statusList: [
        { label: "全部", value: '' },
        { label: "编辑中", value: 1 },
        { label: "征集中", value: 2 },
        { label: "已完成", value: 3 },
      ],
      gridImgUrl: "url('../../assets/grid_icon_def.png')",
      listImgUrl: "url('../../assets/list_icon_sel.png')",
      input: "",
      search1: {},
      token: "",
      modify: false,
      id: "",
      celbin: false,
      tableData: [],
      page: 1,
      pageSize2: 8,
      totals: 0,
      tableDataLen: 0,
      multipleSelection: [],
      loading: false,
      searchReadonly: false
    };
  },
  created() {
    this.token = window.localStorage.getItem("token");
    let type = localStorage.getItem("examType");
    if (type == 1) {
      this.state = 2;
      this.listShow = 1;
      this.gridShow = 1;
    } else {
      this.state = 1;
      this.gridShow = 0;
      this.listShow = 0;
    }
    
    this.loadData()
  },
  mounted() {
    
  },
  methods: {
		language() {
			return window.localStorage.getItem('lang') || this.$defaultLang
		},
    setMydropdHTML() {
			this.$nextTick(() => {
				this.examlist.forEach(item=>{
					if (this.state == 1) {
						this.$refs['hereList' + item.id].appendChild(
							this.$refs[`${item.id}mydropdList`].popperElm
						)
					} else {
						console.log(this.$refs.hereCard)
						this.$refs.hereCard.appendChild(
							this.$refs[`${item.id}mydropdCard`][0].popperElm
						)
					}
				}) 
			})
		},
    loadData() {
      this.loading = true
      // console.log(this.search1)
      let data = qs.stringify({
        "pageIndex": this.pageIndex,
        "pageSize": this.pageSize,
        "state": this.search1.state,
        "title": this.search1.title,
        "createTime": this.search1.startTime
      })
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.examPageListCount}?${data}`,
        method: "post",
        cb(res) {
          that.loading = false
          // console.log({ res });
          if (res.code == 0) {
            res.resultBody.datas.forEach((info) => {
              info.showCardMore = false
              // info.showListMore = false
            })
            that.examlist = res.resultBody.datas
            that.total = res.resultBody.total;
						that.setMydropdHTML()
          } else if (res.code == 1001 && res.resultBody?.datas.length == 0) {
            that.examlist = res.resultBody.datas
            if (that.pageIndex > 1) {
              that.pageIndex--
              that.loadData()
            }
          }
        },
      };
      this.$util.request(params);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log("输出选中的内容", this.multipleSelection);
    },
    // 删除回收站
    perDelete() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: '请选择要删除的项目',
          type: 'warning'
        });
      } else {
        
        this.$prompt(`回收站删除项目将不可恢复,需要输入账户密码确认`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          inputType: 'password',
        })
          .then(({ value }) => {
            // let params = 
            let ids = []
            for (let i = 0; i < this.multipleSelection.length; i++) {
              ids.push(this.multipleSelection[i].id);
            }
            let that = this;
            let params = {
              that: this,
              url: `${this.$config.service.examDelAppman}`,
              method: "post",
              data: {
                ids: ids,
                password: value
              },
              cb(res) {
                console.log({ res });
                if (res.code == 0) {
                  that.$message.success('删除成功')
                  // that.celbin = false
                  that.pagefalse()
                  that.loadData()
                }
              },
            };
            this.$util.request(params);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消清空",
            });
          });
        
      }
    },
    // 回收站中的分页
    handleSizeChange1(val) {
      this.pageSize2 = val;
      this.pagefalse();
    },
    handleCurrentChange1(val) {
      this.page = val;
      this.pagefalse();
    },
    // 恢复
    recovery() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: '请选择要恢复的项目',
          type: 'warning'
        });
      } else {
        let ids = [];
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }
        let that = this;
        let params = {
          that: this,
          url: `${this.$config.service.examRestoreAppman}`,
          method: "post",
          data: ids,
          cb(res) {
            console.log({ res });
            if (res.code == 0) {
              that.$message.success('恢复成功')
              // that.celbin = false
              that.pagefalse()
              that.loadData()
            }
          },
        };
        this.$util.request(params);
      }
    },
    pagefalse() {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.examAppmanByLogInUserId}`,
        method: "POST",
        cb(res) {
          if (res.code == 0) {
            that.tableData = res.resultBody
          } else {
            that.tableData = []
          }
        },
      };
      this.$util.request(params);
    },
    closescelbin() {
      this.celbin = false;
    },
    recyclebin() {
      this.celbin = true;
      this.pagefalse();
    },
    exportProject(id) {
      window.open(
        this.$config.service.exportQuestjions +
          "?id=" +
          id +
          "&Authorization=" +
          "Bearer " +
          window.localStorage.getItem("token")
      );
    },
    wipeData(id) {
      this.searchReadonly = true
      let that = this;
      this.$prompt(`您确定要清空当前数据吗?清空数据需要输入账户密码确认`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        inputType: 'password',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(({ value }) => {
          this.searchReadonly = false
          let params = {
            that: that,
            url: `${that.$config.service.examDeleteExamUnderway}?surveyId=${id}&password=${value}`,
            method: "POST",
            cb(res) {
              if (res.code == 0) {
                that.loadData()
                that.$message.success('清空成功！');
              } else {
                that.$message.error(res.message);
              }
            },
          };
          that.$util.request(params);
        })
        .catch(() => {
          this.searchReadonly = false
          this.$message({
            type: "info",
            message: "已取消清空",
          });
        });
    },
    deleProject(row) {
      console.log(row);
      this.$confirm(`当前项目删除后将移入回收站,可进行恢复。`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        console.log('成功')
        let that = this
        let params = {
          that: this,
          url: `${that.$config.service.examPaperisDel}?id=${row.id}&isdel=1`,
          method: "POST",
          cb(res) {
            if (res.code == 0) {
              row.showCardMore = false
              that.loadData();
              that.$message.success('删除成功');
            } else {
              that.$message.error(res.message);
            }
          },
        };
        that.$util.request(params);
        return
      }).catch((e) => {
        console.log(e)
        console.log('失败')
          this.$message({
              type: 'info',
              message: '已取消删除'
          });
        });
    },
    // 上传文件
    importFile(event) {
      // console.log(event);
      let file = event.target.files[0];
      let formData = new FormData();
      formData.append("multipartFile", file);
      // console.log(formData.get("uploadFile"));
      let that = this;
      that
        .$axios({
          url: this.$config.service.importQuestionnaire,
          method: "POST",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + that.token,
					  'Accept-Language': this.language(),
          },
        })
        .then((res) => {
          if (res.data.code == 0) {
            that.$message.success("导入成功");
            this.hiden = false;
            that.loadData();
            let wid = res.data.resultBody;
            sessionStorage.setItem("wid", wid);
            setTimeout(() => {
              that.$router.replace({ path: "/questionType" });
            }, 400);
            //that.$router.push({path:"/questionType"})
          } else {
            that.$message.error("导入失败，请重新导入");
          }
        });
    },
    importWj() {
      this.hiden = true;
    },
    close() {
      this.hiden = false;
    },
    tocreate() {
      if(sessionStorage.getItem("examId")){
        sessionStorage.removeItem("examId")
        sessionStorage.removeItem("state")
        sessionStorage.removeItem("countFinish")
      }
      this.$router.push({ 
          path: "/createExam",
      });
    },
    toImportQuest() {
      this.$router.push({ 
          path: "/examImportQuestion",
      })
    },
    toTestQuestionBank() {
      this.$router.push({ 
          path: "/testQuestionBank",
      })
    },
    totemplate() {
      this.$router.replace({ path: "/template" });
    },
    publishExam(item) {
      let data = qs.stringify({
						'id': item.id,
						'state': 1
					})
					let that = this
					let params = {
						that: this,
						url: `${this.$config.service.examProjectEditState}?${data}`,
						method: "POST",
						cb(res) {
							console.log(res)
							if(res.code == '0') {
								sessionStorage.setItem("examId", item.id)
                sessionStorage.setItem("state", item.state)
                sessionStorage.setItem("countFinish", item.countFinish)
                setTimeout(() => {
                  that.$router.push({ path: "/createExam" });
                }, 400);
							}
						},
					};
					this.$util.request(params)
    },
    toedit(item) {
      // console.log("输出当前的编辑", item);
      if (item.state == 2 && item.countFinish != 0) {
      this.$confirm(`该考试已收集 ${item.countFinish} 份数据,修改考试可能会影响已收集的数据，考试在修改时，会暂停发布，您需要在修改完之后重新发布才可继续收集数据`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
				  type: 'warning'
        }).then(() => {
          this.publishExam(item)
        }).catch(() => {     
        });
      } else if (item.state == 2 && item.countFinish == 0) {
        this.$confirm(`您修改考试时，考试会暂停发布，您需要在修改完成后重新发布考试才可继续进行数据收集，原考试链接不会改变。`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
				  type: 'warning'
        }).then(() => {
          this.publishExam(item)
        }).catch(() => {    
        });
      } else {
        //  console.log("编辑状态", item);
        sessionStorage.setItem("examId", item.id)
        sessionStorage.setItem("state", item.state)
        sessionStorage.setItem("countFinish", item.countFinish)
        setTimeout(() => {
          this.$router.push({ path: "/createExam" });

        }, 400);
      }
    },
    handleCurrentChange(val) {
      let that = this;
      that.pageIndex = val;
      // let data = this.search1
      this.loadData(this.search1);
    },
    enterImg(index) {
      // console.log("eee");
      this.gridShow = index;
    },
    leaveImg(index) {
      this.gridShow = index;
    },
    enterTable(index) {
      this.listShow = index;
    },
    leaveTable(index) {
      this.listShow = index;
    },
    handleCommand(e, item) {
      console.log(e)
      console.log(item)
      if(e == 'copyQuestionnaire') {
        this.copyQuestionnaire(item.id)
      }else if (e == 'wipeData') {
        this.wipeData(item.id)
      }else if (e == 'deleProject') {
        this.deleProject(item)
      }
    },
    copyQuestionnaire(id) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.examProjectCopy}?surveyId=${id}`,
        method: "post",
        cb(res) {
          if (res.code == 0) {
            that.$message.success("复制项目成功！");
            that.loadData();
            let id = res.message
            sessionStorage.setItem("examId", id);
            sessionStorage.setItem("state", 1)
            sessionStorage.setItem("countFinish", 0)

            // setTimeout(() => {
            //   that.$router.push({ path: "/createExam" });
            // }, 400);
          }
        },
      };
      this.$util.request(params);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadData();
    },
    switchType(type) {
      localStorage.setItem("examType", type);

      if (type == 1) {
        this.state = 2;
        this.listShow = 1;
        this.gridShow = 1;
      } else {
        this.state = 1;
        this.gridShow = 0;
        this.listShow = 0;
      }
			this.setMydropdHTML()
    },
    previewClick(item) {
      sessionStorage.setItem("examId", item.id);
      sessionStorage.setItem("state", item.state)
      sessionStorage.setItem("countFinish", item.countFinish)
      this.$router.push({
        path: '/examPreview',
        query: {
          id: item.id
        }
      })
    },
    publish(item) {
      sessionStorage.setItem("examId", item.id);
      sessionStorage.setItem("state", item.state)
      sessionStorage.setItem("countFinish", item.countFinish)

      this.$router.push({ path: "/sendTest" });
    },
    toViewData(item) {
      sessionStorage.setItem("examId", item.id);
      sessionStorage.setItem("state", item.state)
      sessionStorage.setItem("countFinish", item.countFinish)
      this.$router.push({ path: "/resultStats" });
    },
    search() {
      this.pageIndex = 1;
      this.loadData()
    },
    useNumber(item) {
      sessionStorage.setItem("wid", item.id);
      setTimeout(() => {
        this.$router.replace({ path: "/wjstat" });
      }, 400);
    },
  },
};
</script>
<style scoped lang="scss">
/deep/.el-icon-s-data{
  color: rgb(0, 128, 255);
}
/deep/.el-dialog{
  width: 800px;
}
.el-pagination.is-background{
  text-align: right;
  margin-top: 10px;
}
/deep/.el-table .cell {
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分省略号显示*/
}
/deep/.el-table__empty-block {
  display: none !important;
}
/deep/.el-input__inner {
  border: 1px solid #dcdfe6 !important;
}
/deep/.el-input__inner:focus {
  border: 1px solid #0080ff !important;
}
/deep/.el-popover{
      min-width: auto !important;
}
.pageBtn {
  width: 100%;
  height: 60px;
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
<style>
.bottom-icon {
  display: none;
}
.grid-list:hover .bottom-icon {
  display: block;
}
.grid-list:hover .bottom_top {
  display: none;
}
.page-body {
  min-height: 100vh;
  background: #f5f5f5;
  width: 100%;
}
.my-banner {
  height: 310px;
  width: 100%;
  background: url("../../assets/banner-my.png") no-repeat center;
}
.list-card {
  height: 160px;
}
.list-card-content {
  width: 210px;
  height: 160px;
  background: url("../../assets/list.png") no-repeat center;
  cursor: pointer;
  margin-left: 40px;
}
.list-card-content p {
  font-size: 16px;
  color: #333;
  margin-top: 20px;
}
.my-title {
  font-size: 18px;
  color: #333;
  margin-top: 40px;
}
.function {
  margin-top: 20px;
}
.d-box {
  cursor: pointer;
}
.d-box .del {
  width: 21px;
  height: 21px;
  background: url("../../assets/del_sel_icon.png");
}
.d-box p {
  font-size: 14px;
  margin-left: 12px;
  color: #666;
}
.d-box:hover .del {
  background: url("../../assets/del_icon.png");
}
.d-box:hover p {
  color: #0080ff;
}
.img-btn {
  width: 80px;
  height: 40px;
  border: 1px solid #e1e1e1;
  background: #fff;
  cursor: pointer;
}
.el-button [class*=" el-icon-"],
.el-button [class^="el-icon-"] {
  font-size: 18px;
  color: #606266;
}
.el-button--primary [class*=" el-icon-"],
.el-button--primary [class^="el-icon-"] {
  color: #fff;
}
.select-input {
  width: 110px !important;
  color: #333;
}
.table {
  margin-top: 20px;
  width: 100%;
  background: #fff;
  position: relative;
}
.span {
  color: #0080ff;
  font-size: 14px;
  margin-right: 15px;
  cursor: pointer;
}
.more {
  cursor: pointer;
}
.more-box li {
  cursor: pointer;
  font-size: 14px;
  color: #333;
  margin-top: 10px;
}
.t-f-box:hover .more-box {
  display: block;
}
.more-box li:hover {
  color: #0080ff;
}
.el-table__body-wrapper {
  overflow: visible;
}
.el-table {
  overflow: visible;
}
/* .el-table .cell {
  overflow: visible;
} */
.grid {
  flex-wrap: wrap;
  margin-top: 20px;
}
.grid-list {
  width: 280px;
  height: 216px;
  background: #fff;
  margin-right: 25px;
  border-radius: 5px;
  margin-bottom: 20px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 20px;
  box-sizing: border-box;
}
.grid-list:nth-child(4n) {
  margin-right: 0px;
}
.grid-list-img {
  height: 120px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}
.top-img {
  width: 100%;
  height: 100%;
}
.grid-title {
  margin-top: 15px;
  padding: 0 12px;
}
.wq {
  width: 46px;
  height: 22px;
  background: #d6edff;
  color: #0080ff;
  border-radius: 5px;
  font-size: 12px;
  cursor: pointer;
}
.grid-title p {
  font-size: 14px;
  color: #333;
  width: 74%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.grid-list-bottm {
  padding: 0 12px;
  margin-top: 12px;
}
.kong {
  width: 1200px;
  height: 660px;
  background: #fff;
  margin: 0 auto;
}
.kong img {
  width: 250px;
  height: 233px;
  margin-left: 476px;
  margin-top: 100px;
}
.kong p {
  font-size: 20px;
  text-align: center;
  color: #999999;
  font-family: MicrosoftYahei;
  margin-top: 50px;
}
.mask {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.3;
}
.details {
  /* // 遮罩层内容 */
  position: fixed;
  background: #fff;
  width: 600px;
  height: 240px;
  overflow: auto;
  opacity: 1;
  z-index: 2001;
  top: 30%; /*偏移*/
  left: 50%;
  margin-left: -300px;
}
.details2 {
  position: fixed;
  background: #fff;
  width: 800px;
  height: 590px;
  overflow: auto;
  opacity: 1;
  z-index: 2001;
  top: 20%; /*偏移*/
  left: 45%;
  margin-left: -300px;
}
.details-1 {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: #fff;
  position: relative;
  color: #333;
  border-bottom: 1px solid #0080ff;
  font-size: 18px;
  text-align: center;
}
.details-1 i {
  color: #999;
  position: absolute;
  right: 20px;
  top: 34%;
}
.import_box {
  width: 100%;
  min-height: 150px;
  background: #fff;
  margin-top: 20px;
}
.import_box li {
  padding: 0 30px;
  margin-top: 20px;
}
.el-btn {
  font-size: 16px;
  background: #fff;
  border: 1px solid #0080ff;
  color: #0080ff;
}
.file {
  position: relative;
  display: inline-block;
  background: #0080ff;
  border-radius: 4px;
  padding: 9px 21px;
  overflow: hidden;
  color: #fff;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  font-size: 16px;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.flex {
  align-items: center;
}
el-input:focus {
  border: 1px solis #0080ff;
}
</style>
